module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/policy/policy.component.css
// module id = ./src/app/policy/policy.component.css
// module chunks = main